(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/models/member.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/models/member.js');

(function(Backbone, _, svs) {
  'use strict';

  var api = 0;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 1;
  }
  svs.syndicate.core.models.Member = Backbone.Model.extend({
    preserve: true,

    idAttribute: 'customerId',
    url: function() {
      return svs.core.jupiter.url() + '/social/' + (3 + api) + '/syndicates/' + this.get('syndicateId') + '/member?memberId=' + this.get('customerId');
    },

    initialize: function() {
      this.updateActions();
      this.listenTo(this, 'change:memberState', this.updateActions);
    },

    updateActions: function() {
      var actions = [];
      var isLoggedInMember = this.get('isCurrentMember');
      var isLoggedInMemberOwner = this.isLoggedInMemberOwner();

      if (!isLoggedInMember) {
        if (this.get('email')) {
          actions.push({
            actionClass: 'js-send-email',
            text: 'Skicka e-post'
          });
        }

        if (isLoggedInMemberOwner) {
          if (this.active()) {
            actions.push({
              actionClass: 'js-inactivate-member',
              text: 'Sätt vilande'
            });
          } else if (this.inactive()) {
            actions.push({
              actionClass: 'js-activate-member',
              text: 'Aktivera'
            });
          }

          actions.push({
            actionClass: 'js-remove-member',
            text: 'Ta bort'
          });
        }
      }

      this.set('actions', actions);
    },

    remindMember: function() {
      var self = this;
      var jupiterOptions = {
        path: '/social/1/syndicates/requestreminders',
        data: {
          syndicateId: self.get('syndicateId').toString(),
          customerId: self.get('customerId').toString()
        }
      };
      svs.core.jupiter.post(
        jupiterOptions,
        function() {
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            icon: 'checkmark',
            title: 'Påminnelse skickad till ' + self.get('firstName') + ' ' + self.get('lastName'),
            actions: [{ title: 'Okej' }]
          }));
        },
        function(xhr, textStatus) {
          svs.syndicate.syndicate_detail.logger.error('Error trying to send reminder to', self.get('firstName'), 'error: ', textStatus);

          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            type: svs.ui.dialog.type.ERROR,
            title: 'Kunde inte skicka påminnelse till ' + self.get('firstName') + '.',
            actions: [{ title: 'Okej' }]
          }));
        }
      );
    },

    activateMember: function(syndicate) {
      syndicate.activateMember(this);
    },

    inactivateMember: function(syndicate) {
      syndicate.inactivateMember(this);
    },

    removeMember: function(syndicateModel) {
      var self = this;
      var message;
      var hasMemberBalance = parseInt(this.get('memberBalance'), 0) > 0;

      message = [
        {
          type: svs.ui.dialog.message.TEXT,
          text: 'Vill du ta bort <strong>' + this.memberName(false, false) + '</strong> från laget <strong>' + syndicateModel.get('syndicateName') + '</strong>?',
          align: svs.ui.dialog.message.align.CENTER
        }
      ];
      if (hasMemberBalance) {
        message.push(
          {
            type: svs.ui.dialog.message.TEXT,
            text: svs.utils.format.Currency(this.get('memberBalance')) + ' kr kommer att betalas ut från laget.',
            align: svs.ui.dialog.message.align.CENTER
          },
          {
            type: svs.ui.dialog.message.TEXT,
            text: 'Nytt saldo i lagkassan: ' + svs.utils.format.Currency(parseInt(syndicateModel.get('syndicateBalance'), 10) - parseInt(this.get('memberBalance'), 10)) + ' kr',
            align: svs.ui.dialog.message.align.CENTER
          }
        );
      }
      var actionDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'spela-tillsammans',
        title: 'Bekräfta',
        message: message,
        actions: [
          {
            title: 'Avbryt'
          },
          {
            title: 'Ta bort',
            showLoader: true,
            callback: function() {
              self.destroy({
                wait: true,
                success: function() {
                  var dialog;
                  var memberBalance = self.get('memberBalance');
                  var dialogOptions = {
                    branding: svs.ui.dialog.branding.TUR,
                    type: svs.ui.dialog.type.ERROR,
                    title: self.get('firstName') + ' ' + self.get('lastName') + ' har tagits bort',
                    actions: [
                      {
                        title: 'Okej',
                        callback: function() {
                          dialog.close();
                        }
                      }
                    ]
                  };

                  if (memberBalance) {
                    dialogOptions.message = [
                      {
                        type: svs.ui.dialog.message.TEXT,
                        text: '<strong>' + svs.utils.format.Currency(memberBalance) + ' kr</strong> har utbetalats.'
                      }
                    ];
                  }
                  dialog = new svs.ui.dialog.Confirm(dialogOptions);
                  svs.ui.dialog.api.add(dialog);
                  actionDialog.close();
                  self.trigger('destroy', self);
                },
                error: function(xhr, textStatus) {
                  svs.syndicate.syndicate_detail.logger.error('Error when removing member from syndicate: ' + textStatus);
                  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
                    branding: svs.ui.dialog.branding.TUR,
                    type: svs.ui.dialog.type.ERROR,
                    title: 'Tekniskt fel',
                    message: [
                      {
                        type: svs.ui.dialog.message.TEXT,
                        text: svs.syndicate.core.templates.technical_failure_leave_syndicate(syndicateModel.toJSON())
                      }
                    ],
                    actions: [{ title: 'Okej' }]
                  }));
                  actionDialog.close();
                }
              });
            }
          }
        ]
      });
      svs.ui.dialog.api.add(actionDialog);
    },

    isLoggedInMemberOwner: function() {
      return (this.get('currentMemberRole') & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER) === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER;
    },

    isOwner: function() {
      return (this.get('memberRole') & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER) === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER;
    },

    memberName: function(firstNameOnly, anonymousUppercase) {
      var memberName;

      if (this.get('firstName') || this.get('lastName')) {
        if (firstNameOnly && this.get('firstName')) {
          memberName = this.get('firstName');
        } else {
          memberName = this.get('firstName') + ' ' + this.get('lastName');
        }
      } else {
        memberName = anonymousUppercase ? 'Medlemmen' : 'medlemmen';
      }
      return memberName;
    },

    inactive: function() {
      return this.get('memberState') === svs.syndicate.core.data.constants.syndicateMemberState.INACTIVE;
    },

    active: function() {
      return this.get('memberState') === svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE;
    },

    requestActivateMember: function(syndicate) {
      syndicate.requestActivation(this);
    }
  });
})(Backbone, _, svs);


 })(window);